export type LogoSize = "mini" | "large";

/** App theme: light UI uses dark-colored logo assets and vice versa. */
export type AppThemeMode = "light" | "dark";

const LOGO_BASE = "./assets/images/logos/logos-demo";

export const TREESLO_LOGO_PATHS: Record<
  LogoSize,
  Record<AppThemeMode, string>
> = {
  mini: {
    light: `${LOGO_BASE}/logo-mini-dark.png`,
    dark: `${LOGO_BASE}/logo-mini-ligth.png`,
  },
  large: {
    light: `${LOGO_BASE}/logo-large-dark.png`,
    dark: `${LOGO_BASE}/logo-large-ligth.png`,
  },
};

export function getTreesloLogoPath(
  size: LogoSize,
  theme: AppThemeMode,
): string {
  return TREESLO_LOGO_PATHS[size][theme];
}
